import styles from "./serviceOption.module.scss";

interface ServiceOptionProps {
  value?: boolean;
  onChange?: () => void;
  children: React.ReactNode;
}

export function ServiceOption({ value, onChange, children }: ServiceOptionProps) {
  return (
    <button
      onClick={onChange}
      className={`${styles.button}${value ? ` ${styles.buttonSelected}` : ""}`}
    >
      {children}
      <span
        className={`${styles.indicator}${value ? ` ${styles.indicatorSelected}` : ""}`}
      />
    </button>
  );
}

